<template>
  <Row class="report-clue">
    <Row class="report-header">
      <span>{{ $route.query && $route.query.name || '线索举报' }}</span>
    </Row>
    <Row class="form-content">
      <Form
        ref="formValidate" :model="formValidate" :rules="ruleValidate"
        :label-width="180" @submit.native.prevent
      >
        <FormItem label="" prop="hasProduct">
          <RadioGroup v-model="formValidate.hasProduct" @on-change="changeHasProduct">
            <Radio :label="1">有产品</Radio>
            <Radio :label="0">无产品</Radio>
          </RadioGroup>
        </FormItem>
        <Row v-if="formValidate.hasProduct==1">
          <FormItem label="产品名称" prop="productName">
            <Input v-model.trim="formValidate.productName" placeholder="请输入产品名称" />
          </FormItem>
          <FormItem label="产品单价" prop="price">
            <Input v-model.trim="formValidate.price" placeholder="请输入产品单价" />
          </FormItem>
          <FormItem label="月销量" prop="saleNum">
            <Input v-model.trim="formValidate.saleNum" placeholder="请输入月销量" />
          </FormItem>
        </Row>
        <FormItem label="店铺名称" prop="storeName">
          <Input v-model.trim="formValidate.storeName" placeholder="请输入店铺名称" />
        </FormItem>
        <FormItem label="店铺地址" prop="province">
          <!-- <City ref="transEvent" style="width:100%;" class="city" @listenCity="getCity" /> -->
          <MobileCity
            ref="transEvent" style="width:100%;" class="city"
            @listenCity="getCity"
          />
        </FormItem>
        <FormItem label="详细地址" prop="address">
          <Input v-model.trim="formValidate.address" type="textarea" placeholder="请填写详细地址(不超过256个字符)" />
        </FormItem>
        <FormItem label="调查时间" prop="surveyDate">
          <DatePicker
            :value="formValidate.surveyDate" type="date" placement="bottom-end"
            :placeholder="$t('SelectTime')"
            style="width:100%" @on-change="getTime"
          />
        </FormItem>
        <FormItem label="举报人" prop="reportUser">
          <Input v-model.trim="formValidate.reportUser" placeholder="请输入举报人" />
        </FormItem>
        <FormItem label="联系方式" prop="reportContact">
          <Input v-model.trim="formValidate.reportContact" placeholder="请输入联系方式" />
        </FormItem>
        <FormItem label="备注" prop="remark">
          <Input v-model.trim="formValidate.remark" type="textarea" placeholder="请填写备注信息(不超过256个字符)" />
        </FormItem>
        <!-- <Row class="attachment"><span>侵权照片/录像/附件</span></Row> -->
        <FormItem label="侵权照片/录像/附件" prop="attachmentList">
          <!-- <file-upload :upload-config="uploadConfig" class="upload" :default-list="defaultList" @getFileList="getFileList" /> -->
          <MobilefileUpload
            :upload-config="uploadConfig" class="upload" :default-list="defaultList"
            @getFileList="getFileList"
          />
        </FormItem>
        <p style="margin: 20px 0;font-size:0.9rem;color:red;">【隐私提示】举报人和联系方式为非必填信息，如您自愿填写后，将视为您同意我方使用该信息用于投诉事宜联络使用。我们不会公开您的个人信息，同时为您的信息提供相应的安全保障，以防止信息的丢失、不当使用、未经授权访问或者披露。</p>
        <Row class="btn-style">
          <Button :loading="submitLoading" @click.stop="submit('formValidate')">
              {{$t('Confirm')}}
          </Button>
        </Row>
      </Form>
    </Row>
  </Row>
</template>

<script>

import MobileCity from './components/city.vue'
import MobilefileUpload from './components/fileUpload.vue'

export default {
  metaInfo: {
    meta: [
      { name: 'viewport', content: 'width=device-width' }
    ]
  },
  components: {
    MobileCity,
    MobilefileUpload
  },
  data () {
    const validatePrice = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('产品单价不能为空'))
      }
      if (isNaN(value)) {
        return callback(new Error('请输入数字'))
      }
      const arr = value.split('.')
      if (arr.length === 1 || arr.length === 2) {
        if (Number(arr[0]) > 9999999999) {
          return callback(new Error('整数部分不能超过10位'))
        }
        if (Number(arr[1]) > 99) {
          return callback(new Error('小数部分不能超过2位'))
        }
      } else {
        return callback(new Error('请输入数字'))
      }
      callback()
    }
    const validateSaleNum = (rule, value, callback) => {
      if (isNaN(value)) {
        return callback(new Error('请输入数字'))
      }
      callback()
    }
    return {
      submitLoading: false,
      formValidate: {
        hasProduct: 1,
        productName: '',
        price: '',
        saleNum: '',
        storeName: '',
        province: '',
        city: '',
        area: '',
        address: '',
        surveyDate: '',
        reportUser: '',
        reportContact: '',
        remark: '',
        attachmentList: []
      },
      ruleValidate: {
        hasProduct: [{ required: true, type: 'number', message: '请选择', trigger: 'change' }],
        productName: [
          { required: true, message: '请输入产品名称', trigger: 'blur' },
          { max: 64, message: '长度不能超过64个字符', trigger: 'blur' }
        ], // 64
        price: [
          { required: true, validator: validatePrice, trigger: 'blur' },
          { max: 13, message: '长度不能超过13个字符', trigger: 'blur' }
        ], // 12
        saleNum: [
          { validator: validateSaleNum, trigger: 'blur' },
          { max: 10, message: '长度不能超过10个字符', trigger: 'blur' }
        ], // 11
        storeName: [
          { required: true, message: '请输入店铺名称', trigger: 'blur' },
          { max: 64, message: '长度不能超过64个字符', trigger: 'blur' }
        ], // 64
        province: [{ required: true, message: '请选择地址', trigger: 'change' }],
        address: [
          { required: true, message: '请输入详细地址', trigger: 'blur' },
          { max: 256, message: '长度不能超过256个字符', trigger: 'blur' }
        ],
        surveyDate: [{ required: true, message: '请输选择时间', trigger: 'change' }],
        remark: [{ max: 256, message: '长度不能超过256个字符', trigger: 'blur' }],
        reportUser: [{ max: 64, message: '长度不能超过64个字符', trigger: 'blur' }], // 64
        reportContact: [{ max: 16, message: '长度不能超过16个字符', trigger: 'blur' }], // 16
        attachmentList: [{ required: true, type: 'array', message: '请上传文件', trigger: 'change' }]
      },
      uploadConfig: {},
      investigateTime: [],
      defaultList: []
    }
  },
  mounted() {
    (function flexible(window, document) {
      console.log(1)
      var docEl = document.documentElement
      var dpr = window.devicePixelRatio || 1

      // adjust body font size
      // 设置 em 默认字体所对应的大小
      function setBodyFontSize() {
        if (document.body) {
          document.body.style.fontSize = 12 * dpr + 'px'
        } else {
          document.addEventListener('DOMContentLoaded', setBodyFontSize)
        }
      }
      setBodyFontSize()
      // 将视窗分为多少份
      // set 1rem = viewWidth / 10
      function setRemUnit() {
        var rem = docEl.clientWidth / 10
        docEl.style.fontSize = rem + 'px'
      }

      setRemUnit()
      // 当页面发生改变时，重新设置 rem 所对应的刻度值
      // reset rem unit on page resize
      window.addEventListener('resize', setRemUnit)
      window.addEventListener('pageshow', function(e) {
        // if (e.persisted) {
        setRemUnit()
        // }
      })

      // detect 0.5px supports
      if (dpr >= 2) {
        var fakeBody = document.createElement('body')
        var testElement = document.createElement('div')
        testElement.style.border = '.5px solid transparent'
        fakeBody.appendChild(testElement)
        docEl.appendChild(fakeBody)
        if (testElement.offsetHeight === 1) {
          docEl.classList.add('hairlines')
        }
        docEl.removeChild(fakeBody)
      }
    })(window, document)
    this.defaultTime()
  },
  methods: {
    // 提交数据
    submit (name) {
      // const url = '/business/cust/report/clue/submit'
      const ajaxData = {
        key: this.$route.query && this.$route.query.key || '',
        clueKey: this.$route.query && this.$route.query.clueKey || '',
        memberKey: this.$route.query && this.$route.query.memberKey || ''
      }
      Object.assign(ajaxData, this.formValidate)
      console.log('this.formValidate', this.formValidate)

      this.$refs[name].validate((valid) => {
        console.log('valid222', valid)
        if (valid) {
          console.log('valid', valid)
          this.submitLoading = true
          const url = '/business/job/cust/report/clue/submit'
          this.$post(url, ajaxData).then(res => {
            if (res.code === 0) {
              this.$Message.success('操作成功！')
              this.submitLoading = false
              this.clearForm()
            } else {
              this.$Message.error('操作失败！')
              this.submitLoading = false
            }
          }).catch(err => {
            console.log(err)
            this.submitLoading = false
          })
        }
      })
    },
    // 选择是否有产品
    changeHasProduct(val) {
      if (val !== 1) {
        this.formValidate.productName = ''
        this.formValidate.price = ''
        this.formValidate.saleNum = ''
      }
    },
    // 获取时间
    getTime (date) {
      this.formValidate.surveyDate = date
    },
    // 搜索条件省市区接口
    getCity (data) {
      let area
      if (data.length != 0) {
        if (data.length == 1) {
          this.formValidate.province = data[0].value
          this.formValidate.city = ''
          this.formValidate.area = ''
          area = data[0].label
        } else if (data.length == 2) {
          this.formValidate.province = data[0].value
          this.formValidate.city = data[1].value
          this.formValidate.area = ''
          area = data[0].label + data[1].label
        } else if (data.length == 3) {
          this.formValidate.province = data[0].value
          this.formValidate.city = data[1].value
          this.formValidate.area = data[2].value
          area = data[0].label + data[1].label + data[2].label
        }
      } else {
        this.formValidate.province = ''
        this.formValidate.city = ''
        this.formValidate.area = ''
        area = ''
      }
    },
    // 获取文件list
    getFileList (data) {
      this.formValidate.attachmentList = []
      if (data.length > 0) {
        data.forEach((item, index) => {
          const obj = {
            fileName: item.fileName,
            mediaType: item.mediaType,
            smallUrl: item.smallUrl,
            url: item.url
          }
          this.formValidate.attachmentList.push(obj)
        })
      }
    },
    // 获取时间默认值
    defaultTime() {
      const now = new Date()
      const nowDate = {
        year: now.getFullYear(),
        month: (now.getMonth() + 1) < 10 ? '0' + (now.getMonth() + 1) : (now.getMonth() + 1),
        date: now.getDate() < 10 ? '0' + now.getDate() : now.getDate()
      }
      this.formValidate.surveyDate = nowDate.year + '-' + nowDate.month + '-' + nowDate.date
    },
    // 清空表单
    clearForm() {
      for (const key in this.formValidate) {
        this.formValidate[key] = ''
      }
      this.formValidate.hasProduct = 1
      this.formValidate.attachmentList = []
      this.defaultList = []
      this.$refs.transEvent.clearSelect()
      this.defaultTime()
    }
  }
}
</script>

<style scoped lang="sass">
@import './index.scss'
</style>



// WEBPACK FOOTER //
// src/view/uploadIntelligence/index.vue